/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useEffect, useState } from "react";
import StoreContext from "./StoreContext";
import { storeStorage } from "./store.storage";
import { fetchTenantFullDetails } from "./store.api";

export const StoreProvider = ({ children }) => {
  const [storeData, setStoreData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // تحميل البيانات من localStorage عند التشغيل
  useEffect(() => {
    const saved = storeStorage.get();
    if (saved) setStoreData(saved);
  }, []);

  // حفظ البيانات عند التغيير
  useEffect(() => {
    if (storeData) storeStorage.set(storeData);
    else storeStorage.clear();
  }, [storeData]);

  // جلب البيانات من API
  const fetchStoreData = async (tenantId) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("authToken");
      const data = await fetchTenantFullDetails(tenantId, token);

      const tenantData = data.find(
        (t) =>
          (t.tenantId || t.TenantId) === tenantId ||
          (t.id || t.Id) === tenantId
      );

      if (!tenantData) {
        setError("Store data not found");
        return null;
      }

      setStoreData(tenantData);
      return tenantData;
    } catch (err) {
      setError(err.message || "Failed to fetch store data");
      return null;
    } finally {
      setLoading(false);
    }
  };

  const updateStoreData = (newData) => {
    setStoreData((prev) => ({ ...prev, ...newData }));
  };

  const clearStoreData = () => {
    setStoreData(null);
    storeStorage.clear();
  };

  return (
    <StoreContext.Provider
      value={{
        storeData,
        loading,
        error,
        fetchStoreData,
        updateStoreData,
        clearStoreData,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
